export enum KEY_CODES {
  BACKSPACE = 8,
  ENTER = 13,
  CTRL = 17,
  ESC = 27,
  DELETE = 46,
  A = 65,
  D = 68,
  F = 70,
  P = 80,
  Z = 90,
  _0 = 48,
  _9 = 57,
  COMMAND = 91, // aka left window key
  COMMAND2 = 93, // aka select key
}
